function newPatientWA (payload) {
    var WA = `Nuevo Paciente con ${payload.doctor_name}\n\nEstimado/a ${payload.patient_name}:\nSe ha registrado como nuevo paciente.\n\nEs de suma importancia que complete el formulario en el *siguiente link*, así su tiempo en próximas consultas será más productivo\n`
    return WA;
} 

export {newPatientWA}